import { Language } from '../../models/languages/language.model';
import { CollectionTranslation } from '../../models/collections/collection-translation.model';

export interface CollectionTranslationForm {
  languageId: number;
  languageIso: string;
  name: string;
}

export function buildCollectionTranslationForms(languages: Language[], existing: CollectionTranslation[] = []): CollectionTranslationForm[] {
  return languages.map(l => ({
    languageId: l.languageId,
    languageIso: l.languageIso,
    name: existing.find(t => t.languageId === l.languageId)?.name ?? ''
  }));
}

export function toCollectionTranslations(forms: CollectionTranslationForm[]): CollectionTranslation[] {
  return forms.map(f => {
    const tr = new CollectionTranslation();
    tr.languageId = f.languageId;
    tr.name = f.name;
    return tr;
  });
}

export function getMissingTranslationsCount(languages: Language[], translations: CollectionTranslation[]): number {
  return languages.filter(l => !translations.some(t => t.languageId === l.languageId && t.name.trim() !== '')).length;
}
